// LOCALIZED elapsed label for a turn or a tool call — distinct from
// task-insights.formatElapsed, which builds an unlocalized "1h 12m" for the
// task widgets. Named apart on purpose: two functions with one name in one
// package is how a call site ends up on the wrong one.
//
// Elapsed time for a turn or a tool call. Hours matter: a turn that stalls runs
// until the user notices, and "700м 0с" is what an eleven-hour one used to
// read as — a number nobody can parse into "this has been dead since last
// night". Seconds keep one decimal below a minute (the common case is a few
// seconds and the precision is the point); above it they are whole.
export function formatDurationLabel(
  totalMs: number,
  t: (key: string, params?: Record<string, string | number | boolean>) => string,
  numfmt: Intl.NumberFormat,
  secondsFmt: Intl.NumberFormat = numfmt,
): string {
  const total = Math.max(0, totalMs)
  if (total < 60_000) return t("ui.message.duration.seconds", { count: secondsFmt.format(total / 1000) })
  if (total < 3_600_000) {
    return t("ui.message.duration.minutesSeconds", {
      minutes: numfmt.format(Math.floor(total / 60_000)),
      seconds: secondsFmt.format((total % 60_000) / 1000),
    })
  }
  return t("ui.message.duration.hoursMinutes", {
    hours: numfmt.format(Math.floor(total / 3_600_000)),
    minutes: numfmt.format(Math.floor((total % 3_600_000) / 60_000)),
  })
}
